export const formatCount = (toCount, suffix, suffix_multiple) => {
  let count = 0;
  let countSuffix = suffix_multiple;

  if (Array.isArray(toCount)) {
    count = toCount.length;
  } else if (Number.isInteger(toCount)) {
    count = toCount;
  } else {
    count = 0;
  }

  if (count <= 0) {
    return `${count} ${suffix_multiple}`;
  }

  if (count === 1) {
    countSuffix = suffix;
  }

  return `${count} ${countSuffix}`;
};
